class HomeController {
    constructor(UserDetails) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.UserDetails.get().then((data) => {
                this.user = data;
            });
        };
        this.UserDetails = UserDetails;
    }
}
angular.module('app').component('home', {
    bindings: {},
    templateUrl: 'scripts/app/partials/Home/home.tpl.html',
    controllerAs: 'vm',
    controller: HomeController
});
